package com.hyperether.goodjob.scenes.pricing

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Icon
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Check
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.paint
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.withStyle
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.check_circle
import com.hyperether.goodjob.resources.choose_plan
import com.hyperether.goodjob.resources.current_plan
import com.hyperether.goodjob.resources.manager
import com.hyperether.goodjob.resources.managers
import com.hyperether.goodjob.resources.month
import com.hyperether.goodjob.resources.most_popular
import com.hyperether.goodjob.resources.premium_dark
import com.hyperether.goodjob.resources.users
import com.hyperether.goodjob.resources.you_chose
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.CardBg
import com.hyperether.goodjob.theme.Green
import com.hyperether.goodjob.theme.LandingPageBg
import com.hyperether.goodjob.theme.PopularPricingBoxBg
import com.hyperether.goodjob.theme.PopularPricingText
import com.hyperether.goodjob.theme.PricingBoxBg
import com.hyperether.goodjob.theme.PricingBtnColor
import com.hyperether.goodjob.theme.PricingText
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.currentLanguage
import com.hyperether.resources.stringResource
import com.hyperether.resources.stringResourcePlain
import org.jetbrains.compose.resources.painterResource


@Composable
fun PricingItem(
    isChecked: Boolean,
    onClick: () -> Unit,
    isExistingPlan: Boolean,
    currentPlanExists: Boolean,
    plan: com.hyperether.goodjob.models.Plan,
    modifier: Modifier = Modifier,
    isAdmin: Boolean
) {
    Box {
        Box(
            modifier = modifier
                .fillMaxWidth()
                .padding(top = 4.toScaleDp(), bottom = 4.toScaleDp())
                .border(1.toScaleDp(), Color.LightGray, shape = RoundedCornerShape(12.toScaleDp()))
                .background(Color.White, shape = RoundedCornerShape(12.toScaleDp()))
                .padding(8.toScaleDp()),
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
//                .background(Color.White, shape = RoundedCornerShape(Dp(12f)))
//                .border(Dp(1f), Color.LightGray, shape = RoundedCornerShape(Dp(12f)))
                    .padding(12.toScaleDp()),
                verticalAlignment = Alignment.CenterVertically
            ) {
                CustomCheckbox(
                    isChecked = isChecked,
                    onClick = onClick,
                    modifier = Modifier.padding(start = 12.toScaleDp())
                )

                Spacer(modifier = Modifier.width(8.toScaleDp()))

                Text(
                    text = plan.getName(currentLanguage.value.code).orEmpty(),
                    color = Color.Black,
                    fontWeight = FontWeight.Bold,
                    fontSize = 16.toScaleSp(),
                    modifier = Modifier
                        .weight(1f)
                        .padding(start = 10.toScaleDp()),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )

                Row {
                    Text(
                        text = plan.getPriceString(),
                        fontSize = 14.toScaleSp(),
                        fontWeight = FontWeight.Bold,
                        color = Color.Black,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    if (plan.price != 0.0) {
                        Text(
                            text = stringResource(Res.string.month),
                            fontSize = 14.toScaleSp(),
                            color = Color.DarkGray,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Spacer(modifier = Modifier.width(9.toScaleDp()))
                    } else {
                        Spacer(modifier = Modifier.width(9.toScaleDp()))
                    }
                }
            }

            if (isChecked) {
                PlanDetailsView(
                    textDescription = plan.getDescription(currentLanguage.value.code).orEmpty(),
                    firstTextBenefits = "${plan.limitManagers} ${stringResource(Res.string.manager)} " +
                            "" + "+ ${plan.limitUsers} ${stringResource(Res.string.users)}",
                    secondTextBenefits = plan.getPlanSupport(currentLanguage.value.code).orEmpty(),
                    thirdTextBenefits = plan.getStorage(currentLanguage.value.code).orEmpty()
                )
            }
        }
        if (isExistingPlan) {
            Box(
                modifier = Modifier
                    .align(Alignment.TopEnd)
                    .offset(x = (-16).toScaleDp())
                    .background(BlueApp, shape = RoundedCornerShape(30.toScaleDp()))
                    .padding(horizontal = 12.toScaleDp(), vertical = 4.toScaleDp()),
                contentAlignment = Alignment.Center
            ) {
                val chosenPlanText = if (isAdmin) {
                    stringResource(Res.string.you_chose)
                } else {
                    stringResource(Res.string.current_plan)
                }
                Text(
                    text = chosenPlanText.uppercase(),
                    fontSize = 8.toScaleSp(),
                    color = Color.White,
                    fontWeight = FontWeight.Bold,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        } else if (plan.isPopular == true && !currentPlanExists) {
            Box(
                modifier = Modifier
                    .align(Alignment.TopEnd)
                    .offset(x = (-16).toScaleDp())
                    .background(BlueApp, shape = RoundedCornerShape(30.toScaleDp()))
                    .padding(horizontal = 12.toScaleDp(), vertical = 4.toScaleDp()),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    text = stringResource(Res.string.most_popular),
                    fontSize = 12.toScaleSp(),
                    color = Color.White,
                    fontWeight = FontWeight.Bold,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }
    }
}

@Composable
fun PlanDetailsView(
    textDescription: String,
    firstTextBenefits: String,
    secondTextBenefits: String,
    thirdTextBenefits: String
) {

    Column(
        modifier = Modifier.padding(
            top = 40.toScaleDp(),
            start = 20.toScaleDp(),
            bottom = 20.toScaleDp()
        )
    ) {
        Text(
            text = textDescription,
            color = Color.Gray,
            lineHeight = 20.toScaleSp(),
            textAlign = TextAlign.Left,
            fontSize = 14.toScaleSp(),
            // modifier = Modifier.padding(top = Dp(8f))
        )
        Row(modifier = Modifier.padding(top = 10.toScaleDp())) {
            Image(
                painter = painterResource(Res.drawable.check_circle),
                contentDescription = "check",
                modifier = Modifier
                    .padding(top = 5.toScaleDp())
            )
            Text(
                text = firstTextBenefits,
                color = Color.Black,
                textAlign = TextAlign.Center,
                fontSize = 14.toScaleSp(),
                modifier = Modifier.padding(start = 12.toScaleDp(), top = 3.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )

        }
        Row {
            Image(
                painter = painterResource(Res.drawable.check_circle),
                contentDescription = "check",
                modifier = Modifier
                    .padding(top = 5.toScaleDp())
            )
            Text(
                text = secondTextBenefits,
                color = Color.Black,
                textAlign = TextAlign.Center,
                fontSize = 14.toScaleSp(),
                modifier = Modifier.padding(start = 12.toScaleDp(), top = 3.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )

        }
        Row {
            Image(
                painter = painterResource(Res.drawable.check_circle),
                contentDescription = "check",
                modifier = Modifier
                    .padding(top = 5.toScaleDp())
            )
            Text(
                text = thirdTextBenefits,
                color = Color.Black,
                textAlign = TextAlign.Center,
                fontSize = 14.toScaleSp(),
                modifier = Modifier.padding(start = 12.toScaleDp(), top = 3.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
fun CustomCheckbox(
    isChecked: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .size(24.toScaleDp())
            .clip(CircleShape)
            .background(if (isChecked) Green else Color.White)
            .border(1.toScaleDp(), Color.LightGray, CircleShape)
            .clickable(onClick = onClick),
        contentAlignment = Alignment.Center
    ) {
        if (isChecked) {
            Icon(
                imageVector = Icons.Default.Check,
                contentDescription = "Checked",
                tint = Color.White,
                modifier = Modifier.size(16.toScaleDp())
            )
        }
    }
}

@Composable
fun PricingOption(
    isLanding: Boolean,
    isMobileView: Boolean,
    plan: com.hyperether.goodjob.models.Plan,
    continueToRegister: () -> Unit,
    width: Float
) {

    val planName = plan.getName(currentLanguage.value.code).orEmpty()
    val description = plan.getDescription(currentLanguage.value.code).orEmpty()
    val features = listOf(
        plan.getStorage(currentLanguage.value.code).orEmpty(),
        plan.getPlanSupport(currentLanguage.value.code).orEmpty(),
        plan.limitManagers.toString() + " " + stringResource(Res.string.managers) + "+" +
                plan.limitUsers + " " + stringResource(Res.string.users)
    )
    val isPopular = plan.isPopular ?: false

    Box(
        modifier = Modifier
            .width(
                if (!isMobileView) {
                    312.toScaleDp()
                } else {
                    width.toScaleDp()
                }
            )
            .height(if (!isMobileView) 480.toScaleDp() else 400.toScaleDp())
            .let { baseModifier ->
                if (isPopular) {
                    baseModifier
                        .shadow(10.toScaleDp(), shape = RoundedCornerShape(20.toScaleDp()))
                        .clip(RoundedCornerShape(20.toScaleDp()))
                        .background(
                            shape = RoundedCornerShape(20.toScaleDp()),
                            color = PopularPricingBoxBg
                        )
                        .paint(
                            painter = painterResource(Res.drawable.premium_dark),
                            alignment = Alignment.CenterEnd
                        )
                        .padding(
                            if (!isMobileView) {
                                PaddingValues(
                                    top = 20.toScaleDp(),
                                    start = 40.toScaleDp(),
                                    end = 40.toScaleDp(),
                                    bottom = 40.toScaleDp()
                                )
                            } else {
                                PaddingValues(
                                    top = 13.toScaleDp(),
                                    start = 24.toScaleDp(),
                                    end = 24.toScaleDp(),
                                    bottom = 24.toScaleDp()
                                )
                            }
                        )
                } else {
                    baseModifier
                        .background(
                            color = if (isMobileView) CardBg else Color.Transparent,
                            shape = RoundedCornerShape(26.toScaleDp()),
                        )
                        .padding(if (!isMobileView) 40.toScaleDp() else 24.toScaleDp())
                }
            }
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.SpaceBetween,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Column(
                modifier = if (isPopular) Modifier
                    .fillMaxWidth()
                else Modifier
                    .fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                if (isPopular) {
                    Box(
                        modifier = Modifier
                            .height(28.toScaleDp())
                            .width(122.toScaleDp())
                            .background(
                                PricingBoxBg,
                                shape = RoundedCornerShape(13.toScaleDp())
                            )
                            .align(Alignment.End),
                        contentAlignment = Alignment.Center
                    ) {
                        Text(
                            text = stringResource(Res.string.most_popular),
                            fontSize = 10.toScaleSp(),
                            lineHeight = 12.toScaleSp(),
                            color = Color.White,
                            fontWeight = FontWeight.Bold,
                            textAlign = TextAlign.Center,
                        )
                    }
                }
                Text(
                    text = buildAnnotatedString {
                        withStyle(
                            style = SpanStyle(
                                fontSize = 36.toScaleSp(),
                                fontWeight = FontWeight.W700,
                                color = if (isPopular) PopularPricingText else PricingText
                            )
                        ) {
                            append(plan.getPriceString())
                        }

                        if (plan.price != 0.0) {
                            val period = stringResourcePlain(Res.string.month)
                            withStyle(
                                style = SpanStyle(
                                    fontSize = 17.toScaleSp(),
                                    fontWeight = FontWeight.W400,
                                    color = if (isPopular) PopularPricingText else PricingText
                                )
                            ) {
                                append(" /$period")
                            }
                        }
                    },
                    modifier = Modifier
                        .align(Alignment.Start)
                )
                Spacer(modifier = Modifier.height(20.toScaleDp()))
                Text(
                    text = planName,
                    fontSize = 28.toScaleSp(),
                    fontWeight = FontWeight.W700,
                    color = if (isPopular) PopularPricingText else PricingText,
                    modifier = Modifier
                        .align(Alignment.Start)
                )
                Spacer(modifier = Modifier.height(15.toScaleDp()))
                Text(
                    text = description,
                    lineHeight = 18.toScaleSp(),
                    fontWeight = FontWeight.W400,
                    fontSize = 15.toScaleSp(),
                    color = if (isPopular) PopularPricingText else PricingText,
                    modifier = Modifier
                        .align(Alignment.Start)
                )
                Spacer(modifier = Modifier.height(19.toScaleDp()))
                features.forEach { feature ->
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .align(Alignment.Start),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(
                            painter = painterResource(Res.drawable.check_circle),
                            contentDescription = "Feature icon",
                            tint = if (isPopular) LandingPageBg.copy(alpha = 0.5f) else Color.White.copy(
                                alpha = 0.5f
                            ),
                            modifier = Modifier.size(20.toScaleDp())
                        )

                        Spacer(modifier = Modifier.width(10.toScaleDp()))

                        Text(
                            text = feature,
                            fontSize = 15.toScaleSp(),
                            lineHeight = 18.toScaleSp(),
                            color = if (isPopular) PopularPricingText else PricingText,
                            fontWeight = FontWeight.W400
                        )
                    }
                    Spacer(modifier = Modifier.height(20.toScaleDp()))
                }
            }

            if (!isLanding) {
                Button(
                    onClick = { continueToRegister() },
                    modifier = Modifier
                        .height(46.toScaleDp())
                        .then(
                            if (isMobileView) Modifier.fillMaxWidth()
                            else Modifier.width(207.toScaleDp())
                        )
                        .clip(RoundedCornerShape(50.toScaleDp())),
                    colors = ButtonDefaults.buttonColors(
                        backgroundColor = if (isPopular) BlueApp else PricingBtnColor,
                        contentColor = BlueApp
                    )
                ) {
                    Text(
                        fontWeight = FontWeight.W700,
                        text = stringResource(Res.string.choose_plan),
                        color = PricingText,
                        fontSize = 15.toScaleSp()
                    )
                }
            }
        }
    }
}